import type theme from '#build/ui/popover'
import type { DeepPartial } from '@nuxt/ui'

const popover: DeepPartial<typeof theme> = {
  slots: {
    content: 'shadow-card ring-white focus:outline-hidden z-10 rounded-xl bg-white ring-1',
    arrow: 'fill-cvt-cloud-500',
  },
}

export default popover
